<div class="container-fluid p-v-20 h-100">
    <div class="d-flex flex-column justify-content-between h-100">
        <div class="p-h-40">
            <img class="img-fluid" alt="" src="assets/images/logo/logo.png">
        </div>
        <div class="container">
            <div class="row align-items-center">
                <div class="col-md-8 m-h-auto">
                    <div class="text-center m-b-50">
                        <img class="img-fluid w-90" src="assets/images/others/error-2.png" alt="">
                        <h2 class="font-weight-light font-size-30 m-t-60 m-b-20">Sorry, we're down for maintenance...</h2>
                        <p class="w-70 lh-1-8 m-h-auto font-size-17">Unfortunately the site is down for abit of maintenance right now. But we're doing our best to get things back.</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex p-h-40 justify-content-between">
            <span class="">© 2025 Adpedia</span>
            <ul class="list-inline">
                <li class="list-inline-item">
                    <a class="text-dark text-link" href="">Legal</a>
                </li>
                <li class="list-inline-item">
                    <a class="text-dark text-link" href="">Privacy</a>
                </li>
            </ul>
        </div>
    </div>
</div>